// src/components/common/PageHeader.js
import React from 'react';
import { Grid, Typography, Box, Paper, useTheme } from '@mui/material';

const PageHeader = ({ title, subtitle, icon: Icon, actions }) => {
  const theme = useTheme();
  
  return (
    <Paper 
      sx={{ 
        p: 2, 
        mb: 3, 
        borderRadius: '12px', 
        backgroundImage: `linear-gradient(135deg, ${theme.palette.primary.main}0d, ${theme.palette.secondary.main}0d)`,
        backdropFilter: 'blur(10px)',
        boxShadow: `0 8px 16px rgba(0, 0, 0, 0.1)`,
      }}
    >
      <Grid container alignItems="center" spacing={2}>
        <Grid item xs={12} md={actions ? 4 : 12}>
          <Box display="flex" alignItems="center">
            {Icon && (
              <Box
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: `${theme.palette.primary.main}1a`,
                  color: theme.palette.primary.main,
                  borderRadius: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 2,
                }}
              >
                <Icon />
              </Box>
            )}
            <Box>
              <Typography variant="h5" fontWeight="bold" sx={{ 
                background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}>
                {title}
              </Typography>
              {subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
        {actions && (
          <Grid item xs={12} md={8}>
            <Box display="flex" gap={2} flexWrap="wrap" justifyContent="flex-end">
              {actions}
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default PageHeader;